import { CONTENT } from '../content/runtime.js';
import type { EconomyData, Mission } from './types.js';
import { AIRPORTS, tierIndex } from './airports.js';

/** One ordered objective ladder per airport, validated during the content build. */
export const LADDERS = CONTENT.missions as Mission[][];
export function missionsFor(e: Pick<EconomyData, 'run'>): Mission[] { return LADDERS[tierIndex(e)]; }
export function currentMission(e: Pick<EconomyData, 'run' | 'mission'>): Mission | undefined { return missionsFor(e)[e.mission]; }
export const MISSIONS = LADDERS[0];
/** Act I ends at the Promotion airport. */
export const PROMOTION_AIRPORT = 'SMR';
export function actOne(e: Pick<EconomyData, 'run'>): boolean { return tierIndex(e) <= AIRPORTS.findIndex(a => a.code === PROMOTION_AIRPORT); }
/** True once the current airport's ladder has reached a lesson matching `lesson` (gates follow content, never an index). */
export function lessonReached(e: Pick<EconomyData, 'run' | 'mission'>, lesson: (m: Mission) => boolean): boolean {
    return missionsFor(e).slice(0, e.mission + 1).some(lesson);
}
/** True while the current lesson is the ladder's first one matching `lesson`. */
export function firstLessonOf(e: Pick<EconomyData, 'run' | 'mission'>, lesson: (m: Mission) => boolean): boolean {
    const at = missionsFor(e).findIndex(lesson);
    return at >= 0 && e.mission === at;
}
